const T = require('prop-types');
const React = require('react');
const { default: Typography } = require('@mui/material/Typography');
const { default: Button } = require('@mui/material/Button');
const SimpleDialog = require('components/SimpleDialog');
const { reloadPage } = require('utils/reload');
const { getDevice } = require('utils/device');
const { getUpgradeAction } = require('../utils/app-version-policy');

module.exports = ForceAppUpgradeDialog;

function ForceAppUpgradeDialog({ isForceAppUpgradeMode, apiAppVersion, frontendAppVersion, onAttempt, onContinue }) {

    const isNative = typeof window !== 'undefined' && Boolean(window.cordova);
    const platform = getDevice().split(':')[0];
    const action = getUpgradeAction({
        isNative,
        platform,
        isTeams: process.env.APP_FLAVOUR === 'teams',
        isStaging: /^https:\/\/staging\.nearpeer\.net(?:[:/]|$)/.test(process.env.API_HOST || ''),
        testflightUrl: process.env.APP_TESTFLIGHT_URL
    });
    const isManual = action.kind === 'manual';
    const attempt = () => {

        const persisted = onAttempt();

        if (!action.href && persisted === true) {
            reloadPage();
        }
    };

    return (
        <SimpleDialog
            isOpen={isForceAppUpgradeMode}
            onRequestClose={onContinue}
            title={action.href || isManual ? 'Update Nearpeer' : 'Refresh to update'}
            buttons={(
                <>
                    <Button onClick={onContinue} data-focus-outline='radius:5,padding:2'>
                        Continue for now
                    </Button>
                    {!isManual && <Button
                        component={action.href ? 'a' : 'button'}
                        href={action.href}
                        target={action.href ? '_blank' : undefined}
                        rel={action.href ? 'noopener noreferrer' : undefined}
                        variant='contained'
                        onClick={attempt}
                        data-focus-outline='radius:5,padding:2'
                    >
                        {action.label}
                    </Button>}
                </>
            )}
            content={(
                <Typography>
                    {isManual
                        ? 'Please get the latest staging build from your team. You can continue for now.'
                        : action.href
                        ? `Please update Nearpeer from version ${frontendAppVersion} to version ${apiAppVersion} or newer.`
                        : 'An update is available. Please refresh Nearpeer to use it.'}
                </Typography>
            )}
        />
    );
}

ForceAppUpgradeDialog.propTypes = {
    isForceAppUpgradeMode: T.bool,
    apiAppVersion: T.string,
    frontendAppVersion: T.string,
    onAttempt: T.func.isRequired,
    onContinue: T.func.isRequired
};
